import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isShowLoading: false, // 全局 loading
        // 左侧菜单栏数据
        menuItems: [
            {
                name: 'home', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                // type: 'md-home', // icon类型
                type:'icon-zhuye',
                text: '主页', // 文本内容
            },
            {
                text: '订单', // 文本内容
                type:'icon-dingdan',
                children: [
                    {
                        name: 'transactionDetails', // 要跳转的路由名称 不是路径
                    //    size: 18, // icon大小
                       type: 'icon-shouzhimingxi', // icon类型
                        text: '收支明细', // 文本内容
                    },
                    {
                        name: 'orderManagement', // 要跳转的路由名称 不是路径
                    //    size: 18, // icon大小
                       type: 'icon-dingdanguanli', // icon类型
                        text: '订单管理', // 文本内容
                    },

                    
                    {
                        name: 'reckon', // 要跳转的路由名称 不是路径
                       type: 'icon-dingdanguanli', // icon类型
                        text: '计件管理', // 文本内容
                    },
                    {
                        name: 'print', // 要跳转的路由名称 不是路径
                       type: 'icon-dayin', // icon类型
                        text: '打印', // 文本内容
                    },
                    {
                        name: 'fontLibrary', // 要跳转的路由名称 不是路径
                       type: 'icon-ziku', // icon类型
                        text: '字库', // 文本内容
                    },
                    {
                        text: '统计', // 文本内容
                        type:'icon-dingdan',
                        children: [
                            {
                                name: 'trade', 
                               type: 'icon-shouzhimingxi', 
                                text: '营业情况', 
                            },
                            {
                                name: 'operator', 
                               type: 'icon-shouzhimingxi', 
                                text: '下单统计',
                            },
                            {
                                name: 'pieceCount',
                               type: 'icon-shouzhimingxi', 
                                text: '计件统计', 
                            },
                            {
                                name: 'reconciliation', // 要跳转的路由名称 不是路径
                            //    size: 18, // icon大小
                               type: 'icon-shouzhimingxi', // icon类型
                                text: '客户对账', // 文本内容
                            },
                     
                       //      {
                       //          name: 'orderInfo', // 要跳转的路由名称 不是路径
                       //      //    size: 18, // icon大小
                       // //         type: 'ios-paper', // icon类型
                       //          text: '订单明细', // 文本内容
                       //      },
                        ]
                    },
                    {
                        text: '设置',
                        type:'icon-shezhi',
                        children: [
                            {
                                name: 'customer',
                                type: 'icon-kehuguanli',
                                 text: '客户管理', // 文本内容
                             },
                             {
                                 name: 'staff',
                                type: 'icon-yuangongguanli',
                                 text: '员工管理', // 文本内容
                             },
                             {
                                 name: 'product',
                                 type: 'icon-chanpinshezhi',
                                 text: '产品设置', // 文本内容
                             },
                             {
                                 name: 'collection',
                                 type: 'icon-shoukuanzhanghaoshezhi',
                                 text: '收款账号设置', // 文本内容
                             },
                             {
                                 name: 'distribution',
                                 type: 'icon-peisongfangshishezhi',
                                 text: '配送方式设置', // 文本内容
                             },
                             {
                                name: 'delivery', // 要跳转的路由名称 不是路径
                                type:'icon-peisongshezhi',
                                text: '配送管理', // 文本内容
                            },
                            {
                                name: 'piecework', // 要跳转的路由名称 不是路径
                                type:'el-icon-more',
                                text: '计件设置', // 文本内容
                            },
                            {
                                name: 'special', // 要跳转的路由名称 不是路径
                                type:'el-icon-more',
                                text: '特殊工艺设置', // 文本内容
                            },
                            {
                                name: 'quotation', // 要跳转的路由名称 不是路径
                                type:'el-icon-more',
                                text: '报价设置', // 文本内容
                            },

                            // {
                            //     name: 'automatic', // 要跳转的路由名称 不是路径
                            //     type:'el-icon-more',
                            //     text: '报价设置', // 文本内容
                            // },
                        ]
                       },
               //      {
               //          name: 'orderInfo', // 要跳转的路由名称 不是路径
               //      //    size: 18, // icon大小
               // //         type: 'ios-paper', // icon类型
               //          text: '订单明细', // 文本内容
               //      },
                ]
            },

      
    //         {
    //             name: 'uvFile', // 要跳转的路由名称 不是路径
    //         //    size: 18, // icon大小
    //    //         type: 'ios-paper', // icon类型
    //             text: 'uv文件', // 文本内容
    //         },

            {
                text: '字稿拼版',
               type: 'icon-zigaopinban',
                children: [
                    {
                        name: 'unpacked',
                        type:'icon-daipinban',
                        text: '待拼版',
                    },
                    {
                        name: 'packed',
                        type:'icon-yipinban',
                        text: '已拼版',
                    },
                    {
                        name: 'completed',
                        type:'icon-yiwancheng',
                        text: '已完成',
                    },

                ],
            },
        //     {
        //         text: '参数设置',
        //    //     type: 'ios-paper',
        //         children: [

        //             {
        //                // type: 'ios-grid',
        //                 // name: 'unpacked',
        //                  text: '超级字',
        //                  children:[
        //                     {
        //                    // type: 'ios-grid',
        //                     name: 'superwordGrouted',
        //                     text: '灌胶板',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'superwordFloor',
        //                     text: '底板',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'superwordSideband',
        //                     text: '边带',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'superwordCarving',
        //                     text: '雕刻',
        //                 },

        //             ]
        //             },
        //             {
        //                // type: 'ios-grid',
        //                 // name: 'unpacked',
        //                  text: '无边字',
        //                  children:[
        //                     {
        //                    // type: 'ios-grid',
        //                     name: 'boundlessPanel',
        //                     text: '面板',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'boundlessFloor',
        //                     text: '底板',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'boundlessSideband',
        //                     text: '边带',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'boundlessCarving',
        //                     text: '雕刻',
        //                 },

        //             ]
        //             },
        //             {
        //                // type: 'ios-grid',
        //                 // name: 'unpacked',
        //                  text: '不锈钢字',
        //                  children:[
        //                     {
        //                    // type: 'ios-grid',
        //                     name: 'stainlessSteelPanel',
        //                     text: '面板',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'stainlessSteelFloor',
        //                     text: '底板',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'stainlessSteelSmall',
        //                     text: '小边',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'stainlessSteelSideband',
        //                     text: '边带',
        //                 },
        //                 {
        //                    // type: 'ios-grid',
        //                     name: 'stainlessSteelCarving',
        //                     text: '雕刻',
        //                 },
        //             ]
        //             },

        //    {
        //    // type: 'ios-grid',
        //     // name: 'unpacked',
        //      text: '其他工艺',
        //      name:'other',
        //    },
        //         ],
        //     },
            {
                text: '迷你字',
                type: 'icon-minizi',
                children: [
                     {
                            type: 'icon-mianbanwenjian',
                            name: 'panelFile',
                            text: '面板文件',
                        },
                        {
                            type: 'icon-dibanwenjian',
                            name: 'floorFile',
                            text: '底板文件',
                        },
                        {
                            name: 'archiving', // 要跳转的路由名称 不是路径
                        //    size: 18, // icon大小
                           type: 'icon-wenjiancundang', // icon类型
                            text: '文件存档', // 文本内容
                        },
                        {
                             type: 'icon-minizishezhi',
                            // name: 'unpacked',
                             text: '迷你字设置',
                             // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                             // hidden: true,
                             children:[
                                 {
                                    // type: 'ios-grid',
                                     name: 'offer',
                                     text: '报价',
                                 },
                                 {
                                // type: 'ios-grid',
                                 name: 'panel',
                                 text: '面板',
                             },
                             {
                                // type: 'ios-grid',
                                 name: 'floor',
                                 text: '底板',
                             },
                             {
                                // type: 'ios-grid',
                                 name: 'panelCarving',
                                 text: '面板雕刻',
                             },
                             {
                                // type: 'ios-grid',
                                 name: 'floorCarving',
                                 text: '底板雕刻',
                             },
                             
                             {
                                // type: 'ios-grid',
                                 name: 'process',
                                 text: '特殊工艺',
                             },
                         ]
                         },

                ],
            },
            // {
            //     text: '超级字',
            //  //   type: 'ios-paper',
            //     children: [
            //         {
            //            // type: 'ios-grid',
            //             name: 'superFloor',
            //             text: '底板文件',
            //         },
            //             {
            //                // type: 'ios-grid',
            //                 name: 'carving',
            //                 text: '灌胶文件',
            //             },

            //             {
            //                // type: 'ios-grid',
            //                 name: 'sideband',
            //                 text: '边带文件',
            //             },
            //     ],
            // },
            // {
            //     text: '不锈钢发光字',
            //  //   type: 'ios-paper',
            //     children: [
            //          {
            //                // type: 'ios-grid',
            //                 name: 'steelPanelFile',
            //                 text: '面板文件',
            //             },
            //             {
            //                // type: 'ios-grid',
            //                 name: 'steelFloorFile',
            //                 text: '底板文件',
            //             },
            //             {
            //                // type: 'ios-grid',
            //                 name: 'steelSmallFile',
            //                 text: '小边文件',
            //             },
            //             {
            //                // type: 'ios-grid',
            //                 name: 'steelSidebandFile',
            //                 text: '边带文件',
            //             },
            //     ],
            // },
            // {
            //     text: '无边字',
            // //    type: 'ios-paper',
            //     children: [
            //          {
            //                // type: 'ios-grid',
            //                 name: 'wbzpanelFile',
            //                 text: '面板文件',
            //             },
            //             {
            //                // type: 'ios-grid',
            //                 name: 'wbzfloorFile',
            //                 text: '底板文件',
            //             },

            //             {
            //                // type: 'ios-grid',
            //                 name: 'wbzbxgSideband',
            //                 text: '边带文件',
            //             },
            //     ],
            // },
            // {
            //     text: '背光字',
            //   //  type: 'ios-paper',
            //     children: [
            //          {
            //                // type: 'ios-grid',
            //                 name: 'bgzpanelFile',
            //                 text: '面板文件',
            //             },
            //             {
            //                // type: 'ios-grid',
            //                 name: 'bgzfloorFile',
            //                 text: '底板文件',
            //             },

            //             {
            //                // type: 'ios-grid',
            //                 name: 'bgzSideband',
            //                 text: '边带文件',
            //             },
            //             {
            //                // type: 'ios-grid',
            //                 name: 'bgzCrystal',
            //                 text: '水晶底文件',
            //             },
            //     ],
            // },
            // {
            //     text: '雕刻管理',
            // //    type: 'ios-paper',
            //     children: [
            //          {
            //                // type: 'ios-grid',
            //                 text: '迷你字',
            //                 children: [
            //                     {
            //                        // type: 'ios-grid',
            //                         text: '面板',
            //                         name: 'miniCloutPanel',
            //                     },
            //                     {
            //                        // type: 'ios-grid',
            //                         text: '底板',
            //                         name: 'miniCloutFloor',
            //                     },
            //                 ]

            //             },
            //             {
            //                // type: 'ios-grid',
            //                 text: '超级字',
            //                 name: 'superwordCloutManage',

            //             },
            //             {
            //                // type: 'ios-grid',
            //                 text: '不锈钢字',
            //                 name: 'stainlessCloutManage',

            //             },
            //             {
            //                // type: 'ios-grid',
            //                 text: '无边字',
            //                 name: 'borderlessCloutManage',

            //             },
            //             {
            //                // type: 'ios-grid',
            //                 text: '余料库存',
            //                 children: [
            //                     {
            //                        // type: 'ios-grid',
            //                         text: '迷你字',
            //                         name: 'wasteManage',
            //                     }
            //                 ]
            //             },
            //     ],
            // },

            {
               type: 'icon-cailiaotongji',
                text: '材料管理', 
                children:[
                    {
                        type: 'icon-cailiaotongji',
                        name: 'statistics',
                        text: '用量统计',
                    },
                    {
                    type: 'icon-cailiaotongji',
                    name: 'inventory',
                    text: '入库记录',
                },
                {
                    type: 'icon-cailiaotongji',
                    name: 'stock',
                    text: '库存',
                },
                {
                    name: 'inventory', 
                   type: 'icon-diaokewenjian', 
                    text: '库存料头', 
                },

            ]
            },
            {
                name: 'retouchingFile', // 要跳转的路由名称 不是路径
            //    size: 18, // icon大小
               type: 'icon-zhizuowenjian', // icon类型
                text: '修图文件池', // 文本内容
            },
            {
                name: 'otherFile', // 要跳转的路由名称 不是路径
            //    size: 18, // icon大小
               type: 'icon-zhizuowenjian', // icon类型
                text: '排版文件池', // 文本内容
            },
               {
                name: 'layout', // 要跳转的路由名称 不是路径
            //    size: 18, // icon大小
               type: 'icon-diaokewenjian', // icon类型
                text: '雕刻文件池', // 文本内容
            },
       
            {
                text: '自动拼版设置',
               type: 'icon-zigaopinban',
                children: [
                    {
                        name: 'collage', // 要跳转的路由名称 不是路径
                        type:'el-icon-more',
                        text: '拼版设置', // 文本内容
                    },
                    {
                        type:'el-icon-more',
                        text: '雕刻设置', // 文本内容
                        children:[
                            {
                                name: 'ordinary', 
                                type:'el-icon-more',
                                text: '普通切割', 
                            },
                            {
                                name: 'borderless', 
                                type:'el-icon-more',
                                text: '无边字面板', 
                            },
                            {
                                name: 'superSet', 
                                type:'el-icon-more',
                                text: '超级字', 
                            },
                            {
                                name: 'backlit', 
                                type:'el-icon-more',
                                text: '背光字', 
                            }
                        ]
                    },               {
                        name: 'otherFileSettings', 
                       type: 'icon-wenjianfenleishezhi', 
                        text: '材料工艺分类', 
                    },]},
                    {
                        text: '用户中心',
                       type: 'icon-zigaopinban',
                        children: [
                            {
                                name: 'pointConsme', // 要跳转的路由名称 不是路径
                                type:'el-icon-more',
                                text: '积分', // 文本内容
                            },
                            {
                                name: 'member', // 要跳转的路由名称 不是路径
                                type:'el-icon-more',
                                text: '会员', // 文本内容
                            },
                            {
                                name: 'recharge', // 要跳转的路由名称 不是路径
                                type:'el-icon-more',
                                text: '充值', // 文本内容
                            },
                          ]},

        ],
    },
    mutations: {
        setMenus(state, items) {
            state.menuItems = [...items]
        },
        setLoading(state, isShowLoading) {
            state.isShowLoading = isShowLoading
        },
    },
})

export default store
